var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechcombankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjlJREFUeNrsmLFLw0AUxpNUOnQUdRIbQTsp+AcIFl1bHLuogw6dnMXB1bo5i1gQitDFQTsJdurkIkWnOrQVN0GcKg4Sv5QINeYudy+XingfPF5p+3rfu/drcq1haGlpaWlp/Xe1bduk1c2MRF3bimq8k84cmE6yiTwqU4v375qOdYs88WsNwHgJaQcxj7iGmXFB89tI+4g5mTqlDWDRPc/8lxYQV2GT8MwfDjzlNlGnNmFSsBnY+SDdIbJ2t/UShI2380G6RywF1SmdQIh5g4XTADYskXCyImLD0jecArARqlOGkAA2BgenM0SJUJcVwclShA1LTcQNoidZJ3xVsxRi41fFdIwidrGOx3lCE0I4mTFg46oM41u+jVhGukSkVOJkxYBNxW/eVYRJcHGy4sCG9WIcOJlxYsP5XinDyYoTG4FJvBFxGmMh1CIejey2PZuQrJlEJAlrPQHTHvMqhO7WkI4I420gVkVuPlhjA+mUYL6Gz89zv8R4QwWpSPjwRcS5wGnUNV+mmMfOF4TvA1hoE+mEsFDDMZ3sdOfhg2M+QTGffmz1pM5CKnFSiY3wUUIVTqqxkT6NRsHJM36sEhvp0ygm4ZpYJ9xBXxHPiHcKNmHmpX7QEHDq7yDqanhckGg+FJtIv4kFcfoxftTlvONDZGwiNSBwdWJeNbwmqoy6OupWhvK3Cgcn7vg5ONVRlx/K3yocnITH78Opb14GG6VycUJUCXU5xEV3KpMytLS0tLS0tP6oPgUYAFrEItWaNbagAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechcombankIcon);
export default __webpack_public_path__ + "static/media/techcombank_icon.c1673b6b2406514d2e4674f6f00ee7d4.svg";
export { ForwardRef as ReactComponent };